import {
  GetFrontRichiesteParams,
  GetFrontRichiesteStatoDelega,
  GetFrontRichiesteStatoTipoDomanda,
} from '@framework/api-client';
import { t } from '@framework/i18n';
import { yup } from '@framework/validation';

export type GetFrontExtendedFilters = Pick<
  GetFrontRichiesteParams,
  | 'categorie'
  | 'nomeTitolare'
  | 'cognomeTitolare'
  | 'codiceFiscaleTitolare'
  | 'emailTitolare'
  | 'statoTipoDomanda'
  | 'statoDelega'
  | 'dataAvvioCompilazioneA'
  | 'dataAvvioCompilazioneDa'
  | 'dataInvioCompilazioneA'
  | 'dataInvioCompilazioneDa'
  | 'idGruppoTipoDomanda'
  | 'titoloTipoDomanda'
>;

/**
 * Schema per la validazione dei filtri estesi
 */
export const GetFrontExtendedFiltersSchema: yup.ObjectSchema<GetFrontExtendedFilters> =
  yup.object().shape({
    categorie: yup
      .array(yup.string().required())
      .allowNullable()
      .label(t('extended-filters-schema.categorie', 'Categorie')),
    nomeTitolare: yup
      .string()
      .allowNullable()
      .label(t('extended-filters-schema.nome-titolare', 'Nome Titolare')),
    cognomeTitolare: yup
      .string()
      .allowNullable()
      .label(
        t('extended-filters-schema.cognome-titolare', 'Cognome Titolare'),
      ),
    codiceFiscaleTitolare: yup
      .string()
      .allowNullable()
      .label(
        t(
          'extended-filters-schema.codice-fiscale-titolare',
          'Codice Fiscale Titolare',
        ),
      ),
    emailTitolare: yup
      .string()
      .allowNullable()
      .label(
        t('extended-filters-schema.email-titolare', 'Email Titolare'),
      ),
    statoTipoDomanda: yup
      .string()
      .oneOfEnum(GetFrontRichiesteStatoTipoDomanda)
      .allowNullable()
      .label(
        t(
          'extended-filters-schema.stato-tipo-domanda',
          'Stato Tipo Domanda',
        ),
      ),
    statoDelega: yup
      .string()
      .oneOfEnum(GetFrontRichiesteStatoDelega)
      .allowNullable()
      .label(t('extended-filters-schema.stato-delega', 'Stato Delega')),
    valoriRicercaEstesa: yup
      .string()
      .notRequired()
      .allowNullable()
      .label(
        t(
          'extended-filters-schema.valori-ricerca-estesa',
          'Valori Ricerca Estesa',
        ),
      ),
    dataInvioCompilazioneDa: yup
      .string()
      .stringDate()
      .allowNullable()
      .label(
        t(
          'extended-filters-schema.data-invio-compilazione-da',
          'Data Invio Compilazione Da',
        ),
      ),
    dataInvioCompilazioneA: yup
      .string()
      .stringDate()
      .allowNullable()
      .label(
        t(
          'extended-filters-schema.data-invio-compilazione-a',
          'Data Invio Compilazione A',
        ),
      ),
    dataAvvioCompilazioneDa: yup
      .string()
      .stringDate()
      .allowNullable()
      .label(
        t(
          'extended-filters-schema.data-avvio-compilazione-da',
          'Data Avvio Compilazione Da',
        ),
      ),
    dataAvvioCompilazioneA: yup
      .string()
      .stringDate()
      .allowNullable()
      .label(
        t(
          'extended-filters-schema.data-avvio-compilazione-a',
          'Data Avvio Compilazione A',
        ),
      ),
    idGruppoTipoDomanda: yup
      .string()
      .allowNullable()
      .label(t('extended-filters-schema.tipo-domanda', 'Tipo Domanda')),
    titoloTipoDomanda: yup
      .string()
      .allowNullable()
      .label(
        t(
          'extended-filters-schema.titolo-tipo-domanda',
          'Titolo Tipo Domanda',
        ),
      ),
  });
